import $ from "jquery";

let init = () => {

    $('.js-our-people-info').on('click', (e) => {
        e.preventDefault();

        const data = $(e.target).closest('.js-our-people-info').data('info');

        $('.js-ImageUrl').css('background-image', 'url(' + data.ImageUrl + ')');

        $('.js-Name').text(data.Name);
        $('.js-JobTitle').text(data.JobTitle);
        $('.js-IntroText').html(data.IntroText);
        $('.js-BodyText').html(data.BodyText);

        if (data.LinkedIn) {
            $('.js-LinkedIn').attr('href', data.LinkedIn);
            $('.js-LinkedIn').show();
        } else {
            $('.js-LinkedIn').hide();
        }

        if (data.Email) {
            $('.js-Email').attr('href', 'mailto:' + data.Email);
            $('.js-Email').show();
        } else {
            $('.js-Email').hide();
        }
        
        $.magnificPopup.open({
            items: {
                src: '#our-people-info',
                type: 'inline'
            },
            showCloseBtn: false
        });

    });
}

export let ourPeople = {
	init: init
}